<div id="root">
  <div class="fixed-background">
    <main>
      <div class="container">
        <div>
          <div class="card" style="height: 72vh;margin-top: 9%;">
            <div class="card-body" style="text-align: center;">
              <div style="
                    justify-content: center;
                    align-items: center;
                    display: flex;
                    align-content: space-between;
                    flex-wrap: wrap;
                    flex-direction: column;
                    text-align: center;
                    align-content: center;
                    margin-top: 80px;
                ">
                <img style="width:250px; height:250px;" class="mb-1" src="../../../../../assets/img/Error404.png">
                <p class="font-weight-bold">Lo siento, no tienes permiso para ver la página.</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row h-100">
          <div class="col-12 col-md-10 mx-auto my-auto">
            <div class="card auth-card">
              <div class="position-relative image-side ">
              </div>
              <div class="form-side">
                <a routerLink="/">
                  <span class="logo-single"></span>
                </a>
                <h6 class="mb-4">{{ "pages.error-title" | translate }}</h6>
                <p class="mb-0 text-muted text-small mb-0">
                  {{ "pages.error-code" | translate }}
                </p>
                <p class="display-1 font-weight-bold mb-5">404</p>
                <button class="btn btn-primary btn-lg btn-shadow" (click)="back()" type="submit">
                  {{ "pages.go-back-home" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </main>
  </div>
</div>
